export default "/images/72925023a7b5edf030ce493a92d0882e.avif";